<template>
    <el-container style=" border: 1px solid #eee; ">
        <!-- <el-header style="height: 40px;line-height: 40px;">
            <el-row>
                <el-col :span="24" style="text-align: left;"><el-button type="primary" size="small" round
                        @click="openDialog(null)">添加</el-button></el-col>
            </el-row>
        </el-header> -->
        <el-container>
            <el-aside width="230px" style="background-color: rgb(238, 241, 246);border: solid 1px gray ;">
                <div class="tree-content" style="padding-top: 10px;">
                    <el-tree ref="treeleft" :data="treeData" node-key="id" :indent="0" class="tree-line"
                        :row-style="{'padding-top':'00px','padding-bottom':'0px',height:'30px','line-height':'30px'}"
                        @cell-style="{color:red}" :default-expand-all="isLeftExp" :highlight-current="false"
                        :expand-on-click-node="false" @node-click="handleNodeClick">
                        <span slot-scope="{ data }" class="custom-tree-node">
                            <template>
                                <div class="node_div">
                                    <span class="name-box">
                                        {{ data.name }}
                                        <span v-if="data.itemNum">({{data.itemNum}})</span>
                                    </span>
                                </div>
                            </template>
                        </span>
                    </el-tree>
                </div>
            </el-aside>
            <el-main style="padding: 0;">
                <el-table :data="dataList" style="border: solid 1px gray ;min-height: 400px;height: calc(100%);"
                    @row-click="handleRowClick" class="custom-table" :row-style="{ 'max-height': '60px' }">
                    <el-table-column prop="mainCode" label="系列编码" width="220">
                    </el-table-column>
                    <el-table-column prop="code" label="产品编码" width="160">
                    </el-table-column>
                    <el-table-column prop="typeName" label="产品类型" width="180">
                    </el-table-column>
                    <el-table-column prop="name" label="产品简介" width="380">
                    </el-table-column>

                    <el-table-column prop="isNew" label="新品" width="50">
                    </el-table-column>
                    <el-table-column prop="isMain" label="主页" width="50">
                    </el-table-column>
                    <el-table-column label="操作">
                        <template #default="scope">
                            <el-button size="mini" @click.stop="moveUp(scope.$index)"
                                :disabled="scope.$index === 0||dataList.lenght===1">
                                上移
                            </el-button>
                            <el-button size="mini" @click.stop="moveDown(scope.$index)"
                                :disabled="(scope.$index === dataList.length - 1)||dataList.lenght===1">
                                下移
                            </el-button>
                        </template>
                    </el-table-column>

                </el-table>
            </el-main>
        </el-container>
    </el-container>
</template>
<script>

    import { getProductMain, getProductTypeNum, getupdateSort } from "@/api/rbac/product";
    export default {
        data() {

            return {
                treeData: [],
                dataList: [],
                currentIndex: 0,
                isLeftExp: true,
            }
        },
        created() {
            this.getTypeList();

            this.loadDataList('');
        },
        methods: {
            //获取类型数据
            getTypeList() {
                getProductTypeNum().then(res => {
                    if (res.data.length == 0) {
                        // console.log(this.treeData)
                    }
                    else {
                        this.treeData = res.data;
                    }
                    if (this.treeData.length > 0) {
                        this.$nextTick(() => {
                            this.$refs.treeleft.setCurrentKey(this.treeData[0].id);
                        });
                    }
                })

            },
            handleNodeClick(data, node) {
                console.log('Node clicked:', data, node);

                if (node.data.pID == 0) {
                    this.loadDataList('');
                }
                else {
                    if (node.childNodes.length > 0) {
                        this.loadDataList(' and b.pID=' + node.data.realID);
                    }
                    else {
                        this.loadDataList(' and b.ID=' + node.data.realID);
                    }
                }
                // 在这里处理节点点击的逻辑
            },
            // 点击行时记录当前索引
            handleRowClick(row) {
                this.currentIndex = this.dataList.indexOf(row);
            },
            // 上移操作
            moveUp(index) {
                if (index <= 0) return; // 第一行无法上移
                // 交换数据位置
                const temp = this.dataList[index];
                const temp2 = this.dataList[index - 1];
                
                var sort1=temp.sort
                var sort2=temp2.sort
                try {
                    getupdateSort({ id1: temp.id, id2: temp2.id, sort1: temp.sort, sort2: temp2.sort }).then(res => {
                        if (res.data == 'ok') {
                            this.dataList.splice(index, 1);
                            this.dataList.splice(index - 1, 0, temp);
                            
                            this.dataList[index].sort=sort1
                            this.dataList[index-1].sort=sort2
                            // 更新选中行
                            this.currentIndex = index - 1;
                        }

                    })
                } catch (error) {
                    console.error('获取失败:', error);
                }


            },

            // 下移操作
            moveDown(index) {
                if (index >= this.dataList.length - 1) return; // 最后一行无法下移
                // 交换数据位置
                const temp = this.dataList[index];
                const temp2 = this.dataList[index + 1];
                var sort1=temp.sort
                var sort2=temp2.sort
                try {
                    getupdateSort({ id1: temp.id, id2: temp2.id, sort1: sort1, sort2: sort2 }).then(res => {
                        if (res.data == 'ok') {
                            
                            this.dataList.splice(index, 1);
                            this.dataList.splice(index + 1, 0, temp);
                            this.dataList[index].sort=sort1
                            this.dataList[index+1].sort=sort2
                            // 更新选中行
                            this.currentIndex = index + 1;
                        }

                    })
                } catch (error) {
                    console.error('fail:', error);
                }
                // this.setUpsort(temp.id, temp2.id, temp.sort, temp2.sort);

            },
            setUpsort(id1, id2, sort1, sort2) {
                try {
                    getupdateSort({ id1: id1, id2: id2, sort1: sort1, sort2: sort2 }).then(res => {
                        console.log(res.data)
                    })
                } catch (error) {
                    console.error('获取失败:', error);
                }
            },
            //获取产品数据
            async loadDataList(strWhere) {
                try {
                    getProductMain({ strWhere: strWhere }).then(res => {

                        this.totalData = res.data.length;
                        if (res.data.length == 0) {
                            // console.log(this.dataList)
                            this.dataList = [];
                        }
                        else {
                            this.dataList = res.data;

                        }
                    })


                } catch (error) {
                    console.error('获取失败:', error);
                }
            },
        },
    };
</script>
<style scoped>
    .el-header {
        background-color: #B3C0D1;
        color: #333;
        line-height: 60px;
    }

    .el-aside {
        color: #333;
    }

    ::v-deep(.el-card__body, .el-main) {
        padding: 0px !important;
    }
</style>